import { createContext, useContext, useEffect, useReducer } from "react";
import {
	PROPERTY_REDUCER_GET_ALL_CATEGORY,
	PROPERTY_REDUCER_GET_ALL_DISTRICT,
	PROPERTY_REDUCER_GET_ALL_PROPERTY_LITE,
	PROPERTY_REDUCER_GET_ALL_PROPERTY_TYPE,
	PROPERTY_REDUCER_CREATE_NEW_CATEGORY,
	PROPERTY_REDUCER_UPDATE_CATEGORY,
	PROPERTY_REDUCER_CREATE_NEW_TAG,
	PROPERTY_REDUCER_GET_ALL_TAG,
	PROPERTY_REDUCER_UPDATE_TAG,
	PROPERTY_REDUCER_GET_ALL_SEARCH_INDEX,
	PROPERTY_REDUCER_UPDATE_SEARCH_INDEX,
	PROPERTY_REDUCER_GET_SINGLE_PROPERTY,
	PROPERTY_REDUCER_GET_ALL_PROPERTY,
	PROPERTY_REDUCER_UPLOAD_IMAGES,
} from "../common/constants";
import {
	CategoryReducer,
	DistrictsReducer,
	PropertyLiteReducer,
	PropertyReducer,
	PropertySearchIndexReducer,
	PropertyTypeReducer,
	SinglePropertyReducer,
	TagReducer,
} from "../Reducers/PropertyReducer";
import { LoadingContext } from "./LoadingContext";

export const PropertyContext = createContext();

const PropertyContextProvider = (props) => {
	const [propertyData, setPropertyDataDispatch] = useReducer(PropertyReducer, []);
	const [propertyTypeData, setPropertyTypeDataDispatch] = useReducer(PropertyTypeReducer, []);
	const [districtsData, setDistrictsDataDispatch] = useReducer(DistrictsReducer, []);
	const [categoryData, setCategoryDataDispatch] = useReducer(CategoryReducer, []);
	const [tagData, setTagDataDispatch] = useReducer(TagReducer, []);
	const [propertyDataLite, setPropertyDataLiteDispatch] = useReducer(PropertyLiteReducer, []);
	const [propertySearchIndex, setPropertySearchIndexDispatch] = useReducer(
		PropertySearchIndexReducer,
		[]
	);
	const [singlePropertyData, setSinglePropertyDataDispatch] = useReducer(
		SinglePropertyReducer,
		[]
	);

	const { loadingData, setLoadingData } = useContext(LoadingContext);

	const dispatchMiddleware = (action, dispatch) => {
		console.log("setting loading out ", action);
		if (action.loading) {
			console.log("setting loading inside");
			setLoadingData({
				...loadingData,
				id: action?.loading_id,
				is_loading: action?.loading,
				message: action?.loading_message,
			});
		}
		dispatch({ ...action, dispatch });
	};

	const getAllPropertyData = (successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Loading property data...",
		});

		setPropertyDataDispatch({
			type: PROPERTY_REDUCER_GET_ALL_PROPERTY,
			dispatch: setPropertyDataDispatch,
			loading: true,
			successCb,
			failedCb,
			loadingCb: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
			},
		});
	};

	const getAllCategoriesFromContext = (cb) => {
		setLoadingData({
			is_loading: true,
			message: "Loading category data....",
		});

		setCategoryDataDispatch({
			type: PROPERTY_REDUCER_GET_ALL_CATEGORY,
			loading: true,
			dispatch: setCategoryDataDispatch,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const createNewCategoryFromContext = (data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Creating new category....",
		});

		setCategoryDataDispatch({
			type: PROPERTY_REDUCER_CREATE_NEW_CATEGORY,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const updateCategoryFromContext = (id, data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Updating category....",
		});

		setCategoryDataDispatch({
			type: PROPERTY_REDUCER_UPDATE_CATEGORY,
			id,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const getAllTagsFromContext = (cb) => {
		setLoadingData({
			is_loading: true,
			message: "Loading tag data....",
		});

		setTagDataDispatch({
			type: PROPERTY_REDUCER_GET_ALL_TAG,
			loading: true,
			dispatch: setTagDataDispatch,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const createNewTagFromContext = (data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Creating new tag....",
		});

		setTagDataDispatch({
			type: PROPERTY_REDUCER_CREATE_NEW_TAG,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const updateTagFromContext = (id, data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Updating tag....",
		});

		setTagDataDispatch({
			type: PROPERTY_REDUCER_UPDATE_TAG,
			id,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const getAllPropertyLiteFromContext = (cb) => {
		setLoadingData({
			is_loading: true,
			message: "Loading property data....",
		});

		setPropertyDataLiteDispatch({
			type: PROPERTY_REDUCER_GET_ALL_PROPERTY_LITE,
			loading: true,
			dispatch: setPropertyDataLiteDispatch,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const getAllSearchIndexFromContext = (successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Loading all search index data....",
		});

		setPropertySearchIndexDispatch({
			type: PROPERTY_REDUCER_GET_ALL_SEARCH_INDEX,
			loading: true,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
			dispatch: setPropertySearchIndexDispatch,
		});
	};

	const updateSearchIndexFromContext = (id, data, successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Loading all search index data....",
		});

		setPropertySearchIndexDispatch({
			type: PROPERTY_REDUCER_UPDATE_SEARCH_INDEX,
			loading: true,
			id,
			data,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
			dispatch: setPropertySearchIndexDispatch,
		});
	};

	const getSinglePropertyFromContext = (id, successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Loading property data....",
		});

		setSinglePropertyDataDispatch({
			type: PROPERTY_REDUCER_GET_SINGLE_PROPERTY,
			loading: true,
			id,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
			dispatch: setSinglePropertyDataDispatch,
		});
	};

	const updatePropertyImagesFromContext = (
		id,
		data,
		successCb = () => {},
		failedCb = () => {}
	) => {
		setLoadingData({
			is_loading: true,
			message: "Updating property images data....",
		});

		setPropertyDataDispatch({
			type: PROPERTY_REDUCER_UPLOAD_IMAGES,
			loading: true,
			id,
			data,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
			dispatch: setPropertyDataDispatch,
		});
	};

	useEffect(() => {
		setLoadingData({
			...loadingData,
			is_loading: false,
			message: "",
			is_success: true,
		});
	}, [propertyData]);

	useEffect(() => {
		setPropertyTypeDataDispatch({
			type: PROPERTY_REDUCER_GET_ALL_PROPERTY_TYPE,
			dispatch: setPropertyTypeDataDispatch,
		});
		setDistrictsDataDispatch({
			type: PROPERTY_REDUCER_GET_ALL_DISTRICT,
			dispatch: setDistrictsDataDispatch,
		});
	}, []);

	return (
		<PropertyContext.Provider
			value={{
				propertyData,
				propertyTypeData,
				districtsData,
				categoryData,
				tagData,
				propertyDataLite,
				propertySearchIndex,
				singlePropertyData,
				getAllPropertyData,
				getAllCategoriesFromContext,
				createNewCategoryFromContext,
				updateCategoryFromContext,
				getAllTagsFromContext,
				createNewTagFromContext,
				updateTagFromContext,
				getAllPropertyLiteFromContext,
				getAllSearchIndexFromContext,
				updateSearchIndexFromContext,
				getSinglePropertyFromContext,
				updatePropertyImagesFromContext,
				setPropertyDataDispatch: (action) =>
					dispatchMiddleware(action, setPropertyDataDispatch),
				setPropertyTypeDataDispatch: (action) =>
					dispatchMiddleware(action, setPropertyTypeDataDispatch),
				setDistrictsDataDispatch: (action) =>
					dispatchMiddleware(action, setDistrictsDataDispatch),
				setCategoryDataDispatch: (action) =>
					dispatchMiddleware(action, setCategoryDataDispatch),
				setTagDataDispatch: (action) => dispatchMiddleware(action, setTagDataDispatch),
			}}
		>
			{props.children}
		</PropertyContext.Provider>
	);
};

export default PropertyContextProvider;
